const logError = (message?: any, ...optionalParams: any[]) => {
  console.error(message, ...optionalParams);
};

const logInfo = (message?: any, ...optionalParams: any[]) => {
  console.log(message, ...optionalParams);
};

const logWarning = (message?: any, ...optionalParams: any[]) => {
  console.warn(message, ...optionalParams);
};

export { logError, logInfo, logWarning };
